import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { MultipleSectionsCoverAddedRequiredValiation, coverAddedRequiredValiation, formValidation, resetCoverAddedRequiredValiation, resetMultipleSectionsCoverAddedRequiredValiation, resetValidation } from '../functions/Validation';
import Question from '../components/question/Question';
import FormTitle from '../title/FormTitle';
import BackToTop from '../components/backToTop/BackToTop';
import Assumptions from '../components/assumptions/Assumptions';
/*import TagManager from 'react-gtm-module';*/
import { enableQuestionsInSet, showConditionalChildrenChildren, showConditionalChildrenQuestions, showConditionalQuestionsInSet } from '../functions/QuestionEnabling';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/pro-light-svg-icons'
import '../components/question/validation-message.scss';
import classNames from 'classnames';
import { tracking } from '../functions/Tracking';
import { Action } from '../enums/TrackingActionType';
import { IsWebReference } from '../functions/Configuration';
import DatePicker from '../components/inputs/DatePicker';
import { isDefaultDotNetDate } from '../functions/DateTime'

//const tagManagerArgs = {
//    dataLayer: {
//        userId: '001',
//        userProject: 'CAQWeb',
//        page: 'choosecover'
//    },
//    dataLayerName: 'ChooseCoverPageDataLayer'
//}

export default function ChooseCover(props: any) {
    const navigate = useNavigate();
    const [questions, setQuestions] = useState<any[]>([]);
    const [customerDetails, setCustomerDetails] = useState<CustomerDetails>(JSON.parse(localStorage.getItem('customerDetails') || ""));
    const [showAssumptions, setShowAssumptions] = useState<boolean>(true);
    const [confirmedAssumptions, setConfirmedAssumptions] = useState<boolean>(false);
    const [assumptionValidationFail, setAssumptionValidationFail] = useState<boolean>(false);
    const [readyToNavigate, setReadyToNavigate] = useState(false);
    const [selectedPolicyStart, setSelectedPolicyStart] = useState("");
    const [policyStartValidationFail, setPolicyStartValidationFail] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [scrollToError, setScrollToError] = useState(false);
    const config = JSON.parse(localStorage.getItem('siteConfig') || "{}");
    const [coverStartDateQuestion, setCoverStartDateQuestion] = useState<any>();

    function pad(s: any) { return (s < 10) ? '0' + s : s; }
    var currentStartDate = new Date(new Date().toDateString());
    var currentEndDate = new Date(new Date().toDateString());
    const policyStartDateStart = new Date(currentStartDate.setDate(currentStartDate.getDate())).toISOString().split('T')[0];
    const policyStartDateEnd = new Date(currentEndDate.setMonth(currentEndDate.getMonth() + 1)).toISOString().split('T')[0];


    const formattedPolicyStartDateStart = [pad(currentStartDate.getDate()), pad(currentStartDate.getMonth() + 1), currentStartDate.getFullYear()].join('-');
    const formattedPolicyStartDateEnd = [pad(currentEndDate.getDate()), pad(currentEndDate.getMonth() + 1), currentEndDate.getFullYear()].join('-');

    var inputClasses = classNames(
        {
            'date-text': true,
            'validation-fail': policyStartValidationFail
        }
    );

    let pageNo: number = 3;
    let previousPage = "Employee details";

    if (localStorage.getItem('shortJourney') === "true") {
        pageNo = 2;
        previousPage = "Your business";
    }

    /*TagManager.dataLayer(tagManagerArgs)*/
    props.setSidebarVisibility(true);

    useEffect(() => {
        props.setCurrentPage(pageNo);

        let storedQuestions = localStorage.getItem('questions');

        if (storedQuestions != null) {
            let questionSet = JSON.parse(storedQuestions);


            var sectionQuestions = questionSet.filter((x: { sectionName: string; }) => x.sectionName.toLowerCase().includes("assumptions"));
            if (sectionQuestions[0].questionSetQuestion.visible === true) {
                setShowAssumptions(false);
            }
            if (sectionQuestions[0].questionSetQuestion.visible === false && (sectionQuestions[0].answer != null && sectionQuestions[0].answer !== "")) {
                setConfirmedAssumptions(true);
            }

            setQuestions(questionSet);

            //Create DatePicker Question
            let question = structuredClone(questionSet[0]);//To prevent mutating existing questions[0]
            question.answer = isDefaultDotNetDate(customerDetails.policyStartDate) ? "" : customerDetails.policyStartDate;//To prevent 01/01/0001 appearing in datepicker for new quote
            question.questionSetQuestion.questionID = null;
            question.questionSetQuestion.text = "When would you like your policy to start";
            question.validationMessage = `Please enter a valid date between ${formattedPolicyStartDateStart} & ${formattedPolicyStartDateEnd}`;
            question.questionSetAnswerType.startRange = formattedPolicyStartDateStart;
            question.questionSetAnswerType.endRange = formattedPolicyStartDateEnd;
            question.questionSetAnswerType.answerTypeBaseTypeID = 2;
            question.questionSetQuestion.helpText = "";
            setCoverStartDateQuestion(question);
        }

        let storedCustomerDetails = localStorage.getItem('customerDetails');

        setPageLoaded(true);

    }, [])

    useEffect(() => {
        if (readyToNavigate) {
            localStorage.setItem('customerDetails', JSON.stringify(customerDetails));
            localStorage.setItem('questions', JSON.stringify(questions));
            tracking(Action.SAVE_QUESTIONS);
            navigate("/Loading", {
                state: {
                    pageToLoad: "/YourQuotes",
                    loadingTitle: "Loading",
                    loadingMessage: "Retrieving quotes"
                }
            });
        }
    }, [readyToNavigate])

    useEffect(() => {
        if (scrollToError) {
            if (document.getElementsByClassName('validation-fail-lbl')[0] !== undefined) {
                document.getElementsByClassName('validation-fail-lbl')[0].scrollIntoView({ behavior: 'smooth' });
            }
            setScrollToError(false);
        }
    }, [scrollToError])

    useEffect(() => {
        if (!showAssumptions) {
            const assumptionHeader = Array.from(document.querySelectorAll('.section-header'))
                .find(element => element.textContent?.includes('Assumptions'));
            assumptionHeader?.scrollIntoView({ behavior: 'smooth' });;
        }
    }, [showAssumptions]);

    useEffect(() => {
        if (pageLoaded) {
            let withinRange = true;
            withinRange = new Date(selectedPolicyStart) >= new Date(policyStartDateStart);

            if (withinRange) {
                let endRange = new Date(policyStartDateEnd);

                endRange.setDate(endRange.getDate() + 1);

                endRange = new Date(endRange.toDateString());

                withinRange = new Date(selectedPolicyStart) < endRange
            }

            setPolicyStartValidationFail(!withinRange);
        }

    }, [selectedPolicyStart])

    function nextNavigation() {
        let formValid = true;

        if (!coverStartDateQuestion?.answer || coverStartDateQuestion?.validationFail) {
            setCoverStartDateQuestion((prev: any) => ({
                ...prev,
                validationFail: true
            }));
            formValid = false;
            setScrollToError(true);
        }

        var updatedQuestions = questions.map(question => {
            if (question.page === pageNo) {
                //if the question has already failed another validation then set the formValid to false
                if (question.validationFail) {
                    formValid = false;
                } else {
                    if (formValidation(question)) {
                        question.validationFail = false;
                    } else {
                        formValid = false;
                        question.validationFail = true;
                    }
                }
            }
            if (question.childInformation != null) {
                question.childInformation.map((childquestion: any) => {
                    if (childquestion.page === pageNo) {
                        //if the question has already failed another validation then set the formValid to false
                        if (childquestion.validationFail) {
                            formValid = false;
                        } else {
                            if (formValidation(childquestion)) {
                                childquestion.validationFail = false;
                            } else {
                                if ((question.questionSetQuestion.childQuestionRepeatMinimum > 0 && childquestion.index > 0) || question.questionSetQuestion.childQuestionRepeatMinimum === 0 || question.questionSetQuestion.childQuestionRepeatMinimum == null) {
                                    formValid = false;
                                    childquestion.validationFail = true;
                                }
                            }
                        }
                    }
                    return childquestion;
                });
            }
            return question;
        });

        // if the user hasn't confirmed the assumptions and the assumption questions aren't displayed
        // then the form is not valid
        if (formValid && showAssumptions && !confirmedAssumptions) {
            formValid = false;
            setAssumptionValidationFail(true);
        }

        if (formValid) {
            formValid = !policyStartValidationFail;
        }

        if (formValid && IsWebReference("CA")) {
            let coverValidation = coverAddedRequiredValiation(questions, "Cover Required");
            formValid = coverValidation.valid;
            updatedQuestions = coverValidation.questions;
        }

        if (formValid && IsWebReference("SI")) {
            let coverValidation = MultipleSectionsCoverAddedRequiredValiation(questions, ["Cover Details", "Additional Covers"]);
            formValid = coverValidation.valid;
            updatedQuestions = coverValidation.questions;
        }

        if (formValid) {
            setReadyToNavigate(true);
        } else {
            setQuestions(updatedQuestions);
            setScrollToError(true);
        }
    }

    const resetCoverValidation = () => {
        if (IsWebReference("CA")) {
            let updatedQuestions = resetCoverAddedRequiredValiation(questions, "Cover Required");
            setQuestions(updatedQuestions);
        }

        if (IsWebReference("SI")) {
            let updatedQuestions = resetMultipleSectionsCoverAddedRequiredValiation(questions, ["Cover Details", "Additional Covers"]);
            setQuestions(updatedQuestions);
        }
    }

    function confirmAssumptions() {
        var updatedQuestions = questions.map(question => {
            if (question.page === pageNo && question.sectionName.toLowerCase().includes("assumptions")) {
                var agreeAnswer = "";
                if (["ListValueID", "RadioSelect"].includes(question.questionSetAnswerType.answerTypeName) && question.answerList.some((x: { text: string; }) => x.text.toLocaleLowerCase() === "agree")) {
                    agreeAnswer = question.answerList.filter((x: { text: string; }) => x.text.toLocaleLowerCase() === "agree")[0].value;
                }
                question.answer = agreeAnswer;
            }
            return question;
        });
        setAssumptionValidationFail(false);
        setConfirmedAssumptions(true);
        setQuestions(updatedQuestions);
    }

    function updateAssumptions() {
        var updatedQuestions = questions.map(question => {
            if (question.page === pageNo && question.sectionName.toLowerCase().includes("assumptions")) {
                question.answer = "";
                question.questionSetQuestion.visible = true;
                setShowAssumptions(false);
            }
            return question;
        });
        setAssumptionValidationFail(false);
        setConfirmedAssumptions(false);
        setQuestions(updatedQuestions);
    }
    function backNavigation() {

        var updatedQuestions = resetValidation(questions);

        localStorage.setItem('customerDetails', JSON.stringify(customerDetails));
        localStorage.setItem('questions', JSON.stringify(updatedQuestions));

        if (localStorage.getItem('shortJourney') === "true") {
            navigate("/YourBusiness");
        } else {
            navigate("/EmployeeDetails");
        }
    }

    const showConditionQuestions = (questionID: any, value: any) => {
        let newQuestions = showConditionalQuestionsInSet(questions, questionID, value);
        setQuestions(newQuestions);
    }

    const getIdOfFirstSectionQuestion = (sectionName: string) => {
        var sectionQuestions = questions.filter(x => x.sectionName === sectionName && x.questionSetQuestion.enabled && x.questionSetQuestion.visible && x.page === pageNo);

        // if a section exists with no enabled questions don't show it
        var returnQuestionID = 0;
        if (sectionQuestions.length > 0 && sectionName.toLowerCase() !== "cover essentials") {
            returnQuestionID = sectionQuestions[0].questionSetQuestion.questionID;
        }
        return returnQuestionID;
    }

    const setIndividualCustomerDetails = (question: any) => {
        let customerDetailsUpdated = false;
        let updatedCustomerDetails = customerDetails;

        if (question.questionSetQuestion.text.toLowerCase().includes("start") && question.questionSetQuestion.text.toLowerCase().includes("policy")) {
            updatedCustomerDetails.policyStartDate = question.answer;
            customerDetailsUpdated = true;
        }

        if (customerDetailsUpdated) {
            setCustomerDetails(updatedCustomerDetails);
        }
    }

    const enableQuestions = (questionID: number) => {
        let newQuestions = enableQuestionsInSet(questions, questionID);
        setQuestions(newQuestions);
    }

    const resetRelatedQuestionsValidationOnAnswerChange = (questionID: number) => {
    }

    const showConditionalChildren = (parentQuestionID: number, value: any, firstChildQuestionID: number, firstChildIndex: number, secondChildQuestionID?: number, secondChildIndex?: number) => {
        if (secondChildQuestionID != null && secondChildIndex != null) {
            let newQuestions = showConditionalChildrenChildren(questions, parseInt(parentQuestionID.toString()), parseInt(firstChildQuestionID.toString()), parseInt(secondChildQuestionID.toString()), parseInt(firstChildIndex.toString()), parseInt(secondChildIndex.toString()), value);
            setQuestions(newQuestions);
        } else {
            let newQuestions = showConditionalChildrenQuestions(questions, parseInt(parentQuestionID.toString()), parseInt(firstChildQuestionID.toString()), parseInt(firstChildIndex.toString()), value);
            setQuestions(newQuestions);
        }
    }

    return (
        <>
            <div className="form-container">
                <FormTitle title="Choose cover" />
                <div className="section-header">Cover essentials</div>
                {pageLoaded && <DatePicker
                    question={coverStartDateQuestion}
                    enableQuestions={enableQuestions}
                    setIndividualCustomerDetails={setIndividualCustomerDetails}
                    questionIdPosition={props.questionIdPosition}
                    enableQuickDateSelect={true} />}
                {questions.map((question, index) => {

                    return (<div key={index}>
                        {question.questionSetQuestion.questionID === getIdOfFirstSectionQuestion(question.sectionName) && question.page === pageNo && question.questionSetQuestion.visible &&
                            <div className="section-header" key={question.questionSetQuestion.questionID + "_" + question.questionSetQuestion.sectionID}>{question.sectionName}</div>
                        }
                        <Question question={question} key={question.questionSetQuestion.questionID} showConditionQuestions={showConditionQuestions} enableQuestions={enableQuestions} resetRelatedQuestionsValidationOnAnswerChange={resetRelatedQuestionsValidationOnAnswerChange} page={pageNo} setIndividualCustomerDetails={setIndividualCustomerDetails} showConditionalChildren={showConditionalChildren} resetCoverValidation={resetCoverValidation} questionIdPosition={question.questionSetQuestion.questionID + "-" + question.index} />
                    </div>)
                }
                )}
                {showAssumptions &&
                    <Assumptions confirmAssumptions={confirmAssumptions} updateAssumptions={updateAssumptions} confirmedAssumptions={confirmedAssumptions} validationFail={assumptionValidationFail} />
                }
                <div className="declaration">
                    <p>It is important that all of the above questions are answered honestly and to the best of your knowledge to provide a fair presentation of the risk to the insurer. The information provided will affect their underwriting decision and the policy cover they offer you.</p>
                    <p>Before we proceed, please take a moment to consider if there is any other information you wish to disclose which may affect an insurance policy, if so please contact us on <b>{config.phoneNumber}</b> to discuss further. Failure to provide accurate information may invalidate some or all of your insurance cover.</p>
                </div>
            </div>
            <div className="btn-container">
                <button className="btn back" onClick={() => backNavigation()}>Back: {previousPage}</button>
                <button className="btn primary" onClick={() => nextNavigation()}>Next: Your quotes</button>
            </div>
            <BackToTop />
        </>
    )
}